import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { AxiosConnect } from "../services/axios.connect";
import { useAppContext } from "../context/app.context";
import { handleError } from "../utils/errorHandler";

const ProductManager = () => {
  const { id } = useParams();
  const isEditMode = id == "new" ? false : true;
  const { showAlert } = useAppContext();
  const [btn, setBtn] = useState(false);
  const [formData, setFormData] = useState({
    product_id: "",
    name: "",
    description: "",
    brand: "Axgura",
    images: "",
    stlFile: "",
    totalProduct: "50",
    views: "0",
    likes: "0",
    ready: false,
    survey_id: "",
    blog_id: "",
    link:"",
    twoFactorToken: "",
  });

  useEffect(() => {
    if (isEditMode) {
      AxiosConnect.get(`/v1/product/product-details/${id}`)
        .then((res) => {
          const product = res.data?.data;
          console.log({ product });
          setFormData({
            product_id: product.product_id || "",
            name: product.name || "",
            description: product.description || "",
            brand: product.brand || "Axgura",
            images: product.images ? product.images.join(", ") : "",
            stlFile: product.stlFile || "",
            totalProduct: product.totalProduct || "50",
            views: product.views || "0",
            likes: product.likes || "0",
            ready: product.ready || false,
            survey_id: product.survey_id || "",
            blog_id: product.blog_id || "",
            link: product.link || "",
          });
        })
        .catch((err) => {
          console.error("Error fetching product", err);
        });
    }
  }, [id, isEditMode]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBtn(true);
    const data = {
      ...formData,
      images: formData.images
        ? formData.images.split(",").map((img) => img.trim())
        : [],
    };

    try {
      if (isEditMode) {
        await AxiosConnect.put(`/v1/product/edit/${id}`, data);
      } else {
        await AxiosConnect.post("/v1/product/create-product", data);
      }
      showAlert("success", "Product updated", "Product updated successfully");
    } catch (error) {
      const errorMessage = handleError(error);
      showAlert("error", "Error", "Unable to save product. " + errorMessage);
    } finally {
      setBtn(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6">
        {isEditMode ? "Edit Product" : "Create Product"}
      </h1>
      <form
        onSubmit={handleSubmit}
        className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-8"
      >
        {/* Name */}
        <div className="mb-4">
          <label className="block text-gray-700 font-bold mb-2">Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
          />
        </div>
        {/* Description */}
        <div className="mb-4">
          <label className="block text-gray-700 font-bold mb-2">
            Description
          </label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
          ></textarea>
        </div>
        {/* Brand */}
        <div className="mb-4">
          <label className="block text-gray-700 font-bold mb-2">Brand</label>
          <input
            type="text"
            name="brand"
            value={formData.brand}
            onChange={handleChange}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
          />
        </div>
        {/* Images */}
        <div className="mb-4">
          <label className="block text-gray-700 font-bold mb-2">
            Images (comma separated URLs)
          </label>
          <input
            type="text"
            name="images"
            value={formData.images}
            onChange={handleChange}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
          />
        </div>
        {/* STL File */}
        <div className="mb-4">
          <label className="block text-gray-700 font-bold mb-2">
            STL File URL
          </label>
          <input
            type="text"
            name="stlFile"
            value={formData.stlFile}
            onChange={handleChange}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
          />
        </div>
        {/* Total Product */}
        <div className="mb-4">
          <label className="block text-gray-700 font-bold mb-2">
            Total Product
          </label>
          <input
            type="text"
            name="totalProduct"
            value={formData.totalProduct}
            onChange={handleChange}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
          />
        </div>
        {/* Ready Toggle */}
        <div className="flex items-center mb-4">
          <input
            type="checkbox"
            name="ready"
            checked={formData.ready}
            onChange={handleChange}
            className="mr-2"
          />
          <span className="text-gray-700 font-bold">Ready</span>
        </div>

        {/* Link */}
        <div className="mb-4">
          <label className="block text-gray-700 font-bold mb-2">
            Product Link
          </label>
          <input
            type="text"
            name="link"
            value={formData.link}
            onChange={handleChange}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
          />
        </div>


        {/* Survey ID */}
        <div className="mb-4">
          <label className="block text-gray-700 font-bold mb-2">
            Survey ID
          </label>
          <input
            type="text"
            name="survey_id"
            value={formData.survey_id}
            onChange={handleChange}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
          />
        </div>
        {/* Blog ID */}
        <div className="mb-4">
          <label className="block text-gray-700 font-bold mb-2">Blog ID</label>
          <input
            type="text"
            name="blog_id"
            value={formData.blog_id}
            onChange={handleChange}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 font-bold mb-2">
            Auth Code
          </label>
          <input
            type="text"
            name="twoFactorToken"
            value={formData.twoFactorToken}
            onChange={handleChange}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 focus:outline-none focus:shadow-outline"
          />
        </div>

        {/* Action Buttons */}
        <div className="flex items-center justify-between">
          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
            {btn
              ? "Saving..."
              : isEditMode
              ? "Update Product"
              : "Create Product"}
          </button>
          <button
            type="button"
            onClick={() => (window.location = "/")}
            className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default ProductManager;
